import React from 'react';
import { styled } from '@mui/material';
import { Colors, Text, PrimaryButton } from 'library';
import { track } from 'shared';
import { SearchOff } from '@mui/icons-material';

export default function NoWorkersFound({ signUp }: { signUp: () => void }) {
    return (
        <Container>
            <IconWrapper>
                <SearchOff style={{ fontSize: 48, color: Colors.darkNavy }} />
            </IconWrapper>
            <Text variant="h2" bold textStyle={{ textAlign: 'center', marginBottom: 8 }}>
                No teachers found in this area yet
            </Text>
            <Text textStyle={{ textAlign: 'center', color: Colors.mediumGrey, marginBottom: 24, maxWidth: 420 }}>
                We don't have any available profiles that match your search right now, but new teachers are joining us
                all the time!
            </Text>
            <Divider />
            <Text variant="h2" bold textStyle={{ textAlign: 'center', marginBottom: 8 }}>
                We're expanding quickly!
            </Text>
            <Text textStyle={{ textAlign: 'center', color: Colors.mediumGrey, marginBottom: 20, maxWidth: 420 }}>
                Create an account to be notified when new teachers become available in your area.
            </Text>
            <PrimaryButton
                buttonStyle={{
                    width: 'fit-content',
                    height: 'fit-content',
                }}
                onClick={() => {
                    track('Unsupported Region Customer Clicked Sign Up Button');
                    signUp();
                }}
            >
                Create Free Account
            </PrimaryButton>
        </Container>
    );
}

const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: 16,
    padding: '40px 32px',
    width: '100%',
    maxWidth: 560,
    margin: '0 auto',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    border: `1px solid ${Colors.lightGrey}`,
});

const IconWrapper = styled('div')({
    backgroundColor: Colors.lightTurq,
    borderRadius: '50%',
    width: 80,
    height: 80,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
});

const Divider = styled('div')({
    width: '60%',
    height: 1,
    backgroundColor: Colors.fill,
    margin: '16px 0 24px',
});
